import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useHomeHeroContent } from '../../../../hooks/useHomeHeroContent';
import './Hero.css';

const splitHeroTitle = (title) => {
  const splitIndex = title.search(/\s+Meets\s/i);
  if (splitIndex === -1) {
    return null;
  }

  return [title.slice(0, splitIndex).trim(), title.slice(splitIndex).trim()];
};

const Hero = () => {
  const { content, isLoading } = useHomeHeroContent();
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    const frame = requestAnimationFrame(() => setAnimate(true));
    const fallback = window.setTimeout(() => setAnimate(true), 50);

    return () => {
      cancelAnimationFrame(frame);
      window.clearTimeout(fallback);
    };
  }, []);

  if (isLoading || !content) {
    return null;
  }

  const { title, text, cta, backgroundImage } = content;
  const titleLines = splitHeroTitle(title);

  return (
    <section className={`hero${animate ? ' hero--animate' : ''}`}>
      <img
        className="hero__bg"
        src={backgroundImage}
        alt=""
        aria-hidden="true"
      />
      <div className="hero__overlay" />

      <div className="hero__inner">
        <div className="hero__content">
          <h1 className="hero__title">
            {titleLines
              ? titleLines.map((line) => (
                  <span key={line} className="hero__title-line">{line}</span>
                ))
              : title}
          </h1>
          {text ? <p className="hero__text">{text}</p> : null}
          {cta?.text && cta?.url ? (
            <Link to={cta.url} className="hero__cta luxury-btn">
              {cta.text}
            </Link>
          ) : null}
        </div>
      </div>
    </section>
  );
};

export default Hero;
